var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"homepage"}},[_c('img',{staticClass:"home-feature-image mCS_img_loaded",attrs:{"src":_vm.item.pic_front_path,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }